import {
  HAS_RPS_PASSWORD_ERROR,
  HAS_RPS_VALID_PASSWORD,
} from "../../containers/ForgotPasswordPage/constants";

export const setRpsPasswordStatus = (payload) => {
  return {
    type: payload ? HAS_RPS_PASSWORD_ERROR : HAS_RPS_VALID_PASSWORD,
  };
};



// WEBPACK FOOTER //
// ./src/components/InputField/actions.js